import { render } from "./ListMenu.vue?vue&type=template&id=cedf9fd6"
import script from "./ListMenu.vue?vue&type=script&lang=js"
export * from "./ListMenu.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3223288096/src/application/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__